import { useLocation, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import AddModel from "../../components/Add/AddModel";
import { useState, useEffect } from "react";
import GridTable from "../../components/GridTable/GridTable";
import endpoints from "../../services/endpoints";
import { TableDetailsItem } from "../../components/tables/tableFunctions";
import CustomModal from "../../components/CustomModal";
import useApi from "../../services/useApi";
import { useDispatch } from "react-redux";
import { showToast } from "../../components/toastMessage/toastSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { setMnoUrl } from "../../store/slices/geolocationSlice";
import { setActiveList } from "../../store/slices/activeListSlice";
import { DynamicFilterConfig } from "../../components/DynamicComponent/DynamicFilterPanel";


export default function ListofPurchasedAmount() {
  const [showModel, setShowModel] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const searchPlaceholder = 'transaction id';
  const list = useSelector((state: any) => state.list?.data);
  const { activeList } = useSelector((state: RootState) => state.activeList);
  const selectedTransaction = list?.find((item: any) => item.id === transactionId);
  const navigation = useNavigate(); 
  const dispatch = useDispatch();
  const { PatchAPI } = useApi();
  const { manualEntries } = endpoints;
  const { id } = useParams();
  const [fetchListTrigger, setFetchListTrigger] = useState(false);
  const location = useLocation();

  const isPurchased = activeList === 'Purchased';
  const isPending = activeList === 'Pending';

  // Trigger API call when tab changes
  useEffect(() => {
    setFetchListTrigger(prev => !prev);
  }, [isPurchased, isPending]);

  const TableDetails: { [key: string]: TableDetailsItem } = {
    "Transaction ID": {
      id: "transaction_id",
    },
    "Processed Date": {
      id: "created_at",
      custom: ["created_at"],
    },
    ...(isPurchased && {
      "Purchased Date": {
        id: "purchased_date",
      }
    }),
    "Purchased Amount": {
      id: "purchased_amount",
    },
    ...(isPurchased ? {
      "Purchase Type": {
        id: "purchase_type",
      },
      "Transaction Receipt": {
        id: "receipt_url",
      },
      "Credit Status": {
        id: "credit_status",
      }
    } : {
      "Pending Amount": {
        id: "pending_amount",
      }
    }),
    Actions: {
      id: "actions",
      className: "w-[120px]",
      actionTypes: isPurchased ? ["upgrade", "view"] : ["payment"],
    },
  };

  const handleActions = async (dataId: string, key: string, text?: string) => {
    if (key === "upgrade") {
      setTransactionId(dataId);
      setShowModel(true);
    } else if (key === "view") {
      dispatch(setMnoUrl(location.pathname + location.search))
      navigation(`/mno-management/list-of-mnos/view-mno/${id}/purchased-amount-transaction/view-manual/${dataId}`);
    } else if (key === "payment") {
      navigation(`/mno-management/list-of-mnos/view-mno/${id}/purchased-amount-transaction/pay-due-bill/${dataId}`);
    }
  }

  const handleActiveList = (key: string) => {
    setFetchListTrigger(true)
    dispatch(setActiveList(key));
  };

  const handleStatus = async () => {
    setButtonLoading(true);
    // Perform the status update logic here
    const payload = {
      type: "Update Credit Status",
      details: {
        credit_status: true
      }
    };
    try {
      const response = await PatchAPI(`manual-entries/purchases/${transactionId}`, payload);
      if (!response.error) {
        dispatch(showToast({ type: "success", message: 'Credit status updated successfully' }));
        setShowModel(false);
        setButtonLoading(false);
        setFetchListTrigger(!fetchListTrigger);
      } else {
        dispatch(showToast({ type: "error", message: response.data.message }));
        setShowModel(false);
        setButtonLoading(false);
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  }

  const addButtonClick = () => {
    navigation(`/mno-management/list-of-mnos/view-mno/${id}/purchased-amount-transaction/add-manual`);
  };

  const staticText = {
    emptyScreenText: {
      heading1: `There are no ${activeList.toLocaleLowerCase()} amount transaction added yet`,
      heading2: "Click \"Add Manual\" to create one",
    },
  };

  const renderExtraHeading = () => {
    return (
      <div className="flex flex-row gap-6 pt-6 pb-3 pl-4">
        <div className={`text-subTitle ${isPurchased ? 'text-p_primary border-b-2 border-p_primary' : 'text-gray-400 border-b-2 border-gray-400'}`}>
          <span
            className="cursor-pointer"
            onClick={() => handleActiveList('Purchased')}
          >
            Purchased Amount
          </span>
        </div>
        <div className={`text-subTitle ${isPending ? 'text-p_primary border-b-2 border-p_primary' : 'text-gray-400 border-b-2 border-gray-400'}`}>
          <span
            className="cursor-pointer"
            onClick={() => handleActiveList('Pending')}
          >
            Pending Amount
          </span>
        </div>
      </div>
    );
  };

  const dynamicFilterConfig: DynamicFilterConfig = {
    "Processed Date": {
      label: "Processed Date",
      type: "date",
      required: false,
      searchKey: {
        start: "processed_start_date",
        end: "processed_end_date",
      },
    },
    ...(isPurchased && {
      "Purchased Date": {
        label: "Purchased Date",
        type: "date",
        required: false,
        searchKey: {
          start: "purchased_start_date",
          end: "purchased_end_date",
        },
      },
      "Credit Status": {
      label: "Credit Status",
      type: "radio",
      options: ["All", "Received", "Pending"],
      default: "All",
      required: false,
      searchKey: "credit_status",
      valueMapping: {
        All: "",
        Received: "true",
        Pending: "false",
      }
    },
    }),
  };

  return (
    <div>
      <Breadcrumbs
        navPath={["MNO Management", "List of MNO's", "View Details", "List of Purchased Amount Transaction"]}
        heading="List of Purchased Amount Transaction"
        noNavigation
        links={["/mno-management/list-of-mnos", "/mno-management/list-of-mnos", `/mno-management/list-of-mnos/view-mno/${id}`, `/mno-management/list-of-mnos/view-mno/${id}/purchased-amount-transaction`]}
        button={{
          buttonName: "Add Manual",
          className: "w-[140px]",
          buttonOnclick: addButtonClick,
        }}
        hasAddPrivilege={true}
      />
      <GridTable
        staticText={staticText}
        mainEndPoint={`${manualEntries}${id}`}
        TableDetails={TableDetails}
        handleActions={handleActions}
        params={{ page_number: "1" }}
        extraParams={isPending ? "&payment_status=false" : ""}
        searchPlaceholder={`Search by ${searchPlaceholder}`}
        filters={true}
        exporting={true}
        hasListPrivilege={true}
        hasEditMDPrivilege={true}
        hasViewMDPrivilege={true}
        notfoundRoute={{ state: { route: '/mno-management/list-of-mnos' } }}
        fetchListTrigger={fetchListTrigger}
        renderExtraHeading={renderExtraHeading}
        filterShimmer={true}
        customHeight="h-[110px]"
        dynamicFilterConfig={dynamicFilterConfig}
        forceFullWidth={true}
      />
      {showModel && (
        <CustomModal
          isOpen={showModel}
          onClose={() => setShowModel(false)}
          title={'Update Credit Status '}
          subText={`Are you sure you want to update the credit status for Transaction ID: ${selectedTransaction.transaction_id} to 'Received' for AFA ${selectedTransaction.purchased_amount}?`}
          primaryButtonText={'Update'}
          secondaryButtonText={'Cancel'}
          handelSubmit={handleStatus}
          buttonColor={'bg-p_primary'}
          buttonLoading={buttonLoading}
          buttonWidth={'w-[108px]'}
        />
      )}
    </div>
  );
}